import { render, staticRenderFns } from "./FiltrosBusqueda.vue?vue&type=template&id=0c5813b9&scoped=true"
import script from "./FiltrosBusqueda.vue?vue&type=script&lang=js"
export * from "./FiltrosBusqueda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5813b9",
  null
  
)

export default component.exports